import { useMemo } from 'react';

/**
 * Custom hook for filtering dishes based on category and search query
 * @param {Array} dishes - Array of dish objects
 * @param {string} activeCategory - Currently selected category
 * @param {string} searchQuery - Search query string
 * @returns {Array} Filtered dishes
 */
export const useDishFilters = (dishes, activeCategory, searchQuery) => {
  return useMemo(() => {
    let filtered = dishes;

    // Filter by category
    if (activeCategory !== 'all') {
      filtered = filtered?.filter(dish => dish?.category === activeCategory);
    }

    // Filter by search query
    if (searchQuery?.trim()) {
      const query = searchQuery?.toLowerCase();
      filtered = filtered?.filter(dish => 
        dish?.name?.toLowerCase()?.includes(query) ||
        dish?.description?.toLowerCase()?.includes(query) ||
        dish?.ingredients?.some(ingredient => ingredient?.toLowerCase()?.includes(query))
      );
    }

    return filtered;
  }, [dishes, activeCategory, searchQuery]);
};

export default useDishFilters;